import { useHref } from '@remix-run/react';
import { format, zonedTimeToUtc } from 'date-fns-tz';
import { startCase } from 'lodash-es';
import React from 'react';

import { cn } from '#app/utils/misc.tsx';

const getDateStr = (date: string) =>
  format(zonedTimeToUtc(date, 'Europe/Madrid'), 'dd/MM/yy', {
    timeZone: 'Europe/Madrid',
  });

export function WidgetPageContainer({
  width,
  children,
  type = 'png',
  startDate,
  endDate,
  dashboardSlug,
  title = `Dashboard: ${startCase(dashboardSlug.replace(/-/g, ' '))} — ${getDateStr(startDate)} - ${getDateStr(endDate)}`,
}: {
  type: string;
  title?: string;
  startDate: string;
  endDate: string;
  dashboardSlug: string;
  width: string | number;
  children: React.ReactNode;
}) {
  const href = useHref(
    `/tunnels/${dashboardSlug}?startDate=${startDate}&endDate=${endDate}`,
  );
  return (
    <div className="p-8">
      <h1 className="text-subtitle">
        <a className="text-blue-600 underline" href={href}>
          {title}
        </a>
      </h1>
      {/* This extra div is needed to wrap the extra space of widget */}
      <div className="flex">
        <div id="widget" className="flex p-4">
          <div
            className={cn('bg-secondary', {
              'rounded-2xl px-8 py-11 shadow-2xl': type !== 'pdf',
            })}
          >
            <div style={{ width, maxWidth: width }}>{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
